export class NavigationSection {
    // staff
    nav;

    constructor() {
        this.init();
    }

    init() {
        this.nav = $('.navigation-section');

        if (!this.nav.length) {
            return;
        }

        this.set();
        this.bindEvents();
    }

    set() {
        this.nav.find('.navigation-section__menu').children('li').has('.lnk[href~="' + window.location.pathname + '"]').addClass('active');
    }

    bindEvents() {
        this.nav.on('click', '.navigation-section__label', (e) => this.toggleActive(e));
    }

    toggleActive(e) {
        e.preventDefault();
        $(e.currentTarget).toggleClass('navigation-section__label--active');
    }
}
